import { utilHelper } from "../../_helpers";

const relativeUrl = 'api/dailyTranslationCount';

export const dailyTranslationCountService = {
    search,
};

//search
function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data:data, showAlert:false })
}
